import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setBaseUrl } from '../../redux/modules/settings';

class ScrollToTop extends React.Component {
  static propTypes = {
    location: PropTypes.object,
    children: PropTypes.node
  };

  static defaultProps = {
    location: {},
    children: null
  };

  componentDidMount() {
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    this.props._setBaseUrl(baseUrl);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

const mapDispatchToProps = {
  _setBaseUrl: setBaseUrl,
};

export default connect(null, mapDispatchToProps)(ScrollToTop);



// WEBPACK FOOTER //
// ./src/components/ScrollToTop/ScrollToTop.js